// Autogenerated file
export const idlenessStatusesEnum = {
    Idle: "Idle",
    Busy: "Busy",
};
export const idlenessStatuses = [
    { label: "Свободна", value: "Idle" },
    { label: "Занята", value: "Busy" },
];
